import type { AuditEventSummary, ChangeEntry } from '../../api/client.ts';

const show = (value: unknown) => (value === undefined ? '∅' : typeof value === 'string' ? value : JSON.stringify(value));

export const formatChange = (change: ChangeEntry) => `${change.path}: ${show(change.before)} → ${show(change.after)}`;

export const actorLabel = (actor: AuditEventSummary['actor']) =>
  actor.email ?? (actor.type === 'system' ? 'System' : actor.type === 'server_key' ? `Server key ${actor.id ?? ''}`.trim() : 'Unknown');

export const formatTime = (iso: string) => new Date(iso).toISOString().replace('T', ' ').slice(0, 16) + ' UTC';
